/**
 * Typed manifest of the original 2008 assets (copied from original-2008/game/Gravity/{gfx,sound}).
 * Paths are relative to `public/assets/`. Keys are what Phaser's texture/audio caches use.
 * `asd3.png` (placeholder bitmap font) is deliberately not imported.
 */

export const IMAGES = {
	background: "gfx/background.png",
	shipBlue: "gfx/ship_blue.png",
	shipBlueThrottle: "gfx/ship_blue_throttle_f1.png",
	// Not from 2008: recoloured from the blue ship by scripts/generate-ship-colors.mjs (P11.3).
	shipGreen: "gfx/ship_green.png",
	shipGreenThrottle: "gfx/ship_green_throttle_f1.png",
	shipYellow: "gfx/ship_yellow.png",
	shipYellowThrottle: "gfx/ship_yellow_throttle_f1.png",
	shipRed: "gfx/ship_red.png",
	shipRedThrottle: "gfx/ship_red_throttle_f1.png",
	shipDestroy1: "gfx/ship_destroy_1.png",
	shipDestroy2: "gfx/ship_destroy_2.png",
	shipDestroy3: "gfx/ship_destroy_3.png",
	shipDestroy4: "gfx/ship_destroy_4.png",
	planetMars: "gfx/planet_mars.png",
	planetEarth: "gfx/planet_earth.png",
	planetPluto: "gfx/planet_pluto.png",
	asteroid: "gfx/asteroid.png",
	asteroidInsert1: "gfx/asteroid_insert_1.png",
	asteroidInsert2: "gfx/asteroid_insert_2.png",
	asteroidInsert3: "gfx/asteroid_insert_3.png",
	asteroidInsert4: "gfx/asteroid_insert_4.png",
	asteroidInsert5: "gfx/asteroid_insert_5.png",
	asteroidInsert6: "gfx/asteroid_insert_6.png",
	asteroidInsert7: "gfx/asteroid_insert_7.png",
	asteroidInsert8: "gfx/asteroid_insert_8.png",
	asteroidDestroy1: "gfx/asteroid_destroy_1.png",
	asteroidDestroy2: "gfx/asteroid_destroy_2.png",
	asteroidDestroy3: "gfx/asteroid_destroy_3.png",
	asteroidDestroy4: "gfx/asteroid_destroy_4.png",
	laser: "gfx/laser.png",
	missile: "gfx/missile.png",
	spawnPointFree: "gfx/spawn_point_free.png",
	spawnPointOccupied: "gfx/spawn_point_occupied.png",
	// Not in the original: generated by scripts/generate-pickup-sprites.mjs.
	pickupFuel: "gfx/pickup_fuel.png",
	pickupMissiles: "gfx/pickup_missiles.png",
	pickupTriple: "gfx/pickup_triple.png",
	pickupWarp: "gfx/pickup_warp.png",
	pickupShield: "gfx/pickup_shield.png",
	pickupFreeze: "gfx/pickup_freeze.png",
	pickupHoming: "gfx/pickup_homing.png",
	pickupRepair: "gfx/pickup_repair.png",
	minimapBg: "gfx/worldmap.png",
	minimapPlanet: "gfx/worldmap_planet.png",
	minimapShipBlue: "gfx/worldmap_ship_blue.png",
	minimapShipRed: "gfx/worldmap_ship_red.png",
	minimapShipGreen: "gfx/worldmap_ship_green.png",
	minimapShipYellow: "gfx/worldmap_ship_yellow.png",
} as const;

export const SOUNDS = {
	laser: "sfx/laser.wav",
	missile: "sfx/missile.wav",
	explosion: "sfx/explosion.wav",
	boing: "sfx/boing.wav",
	/** Not from 2008: generated by scripts/generate-pickup-sound.mjs (P10.10). */
	pickup: "sfx/pickup.wav",
	/** Not from 2008: the looping thrust, generated by scripts/generate-engine-sound.mjs (P11.9). */
	engine: "sfx/engine.wav",
} as const;

export const MAPS = {
	classic: "maps/map1.json",
	binary: "maps/binary.json",
	plutoField: "maps/pluto-field.json",
	crossfire: "maps/crossfire.json",
} as const;

export type ImageKey = keyof typeof IMAGES;
export type SoundKey = keyof typeof SOUNDS;
export type MapKey = keyof typeof MAPS;

/** Frame sequences as used by the original AnimationSprite.cpp. */
export const ANIMATIONS = {
	shipDestroy: ["shipDestroy1", "shipDestroy2", "shipDestroy3", "shipDestroy4"],
	asteroidInsert: [
		"asteroidInsert1",
		"asteroidInsert2",
		"asteroidInsert3",
		"asteroidInsert4",
		"asteroidInsert5",
		"asteroidInsert6",
		"asteroidInsert7",
		"asteroidInsert8",
	],
	// legacy: only F1-F3 are registered; asteroid_destroy_4.png exists but is unused.
	asteroidDestroy: ["asteroidDestroy1", "asteroidDestroy2", "asteroidDestroy3"],
} as const satisfies Record<string, readonly ImageKey[]>;

export type AnimationKey = keyof typeof ANIMATIONS;
